import React from 'react';
import { BigNumber } from 'ethers';

export type WalletAssetsContextValue = {
  balance?: BigNumber;
  readBalance: () => void;
  fancyBears?: number[];
  readFancyBears: () => void;
  honeyJars?: number[];
  readHoneyJars: () => void;
  honeyBalance?: BigNumber;
  readHoneyBalance: () => void;
  honeyInJars?: Record<number, BigNumber>;
  readHoneyInJars: () => void;
  isLoading: boolean;
};

// @ts-ignore
const WalletAssetsContext = React.createContext<WalletAssetsContextValue>();

WalletAssetsContext.displayName = 'WalletAssetsContext';

export default WalletAssetsContext;
